import { expandPlaygroundText } from "./expandPlaygroundText";
import {
  interpolatePlaygroundMessage,
  type PlaygroundMsgValues,
} from "./interpolatePlaygroundMessage";
import { usePlaygroundLocalization } from "./PlaygroundLocalizationContext";

export type { PlaygroundMsgValues };

export const usePlaygroundLocalMsg = (
  defaultMessage: string,
  values?: PlaygroundMsgValues
): string => {
  const { expandText } = usePlaygroundLocalization();
  const message = expandText
    ? expandPlaygroundText(defaultMessage)
    : defaultMessage;

  return interpolatePlaygroundMessage(message, values);
};
